"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _Skeleton = _interopRequireDefault(require("../../Skeleton"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _Typography = _interopRequireDefault(require("../../Typography"));

var _useRoundNumber = _interopRequireDefault(require("../../hooks/useRoundNumber"));

var _useIsLoading = _interopRequireDefault(require("../LoadingProvider/useIsLoading"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1hs3udm-Salary",
  styles: "border:0;;label:Salary;"
} : {
  name: "1hs3udm-Salary",
  styles: "border:0;;label:Salary;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Salary = function Salary(props) {
  var _props$grossHourlyRat = props.grossHourlyRate,
      grossHourlyRate = _props$grossHourlyRat === void 0 ? 0 : _props$grossHourlyRat,
      TypographyProps = props.TypographyProps,
      other = (0, _objectWithoutProperties2["default"])(props, ["grossHourlyRate", "TypographyProps"]);

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  var t = (0, _useTranslation["default"])();
  var isLoading = (0, _useIsLoading["default"])();
  var roundedGrossHourlyRate = (0, _useRoundNumber["default"])(grossHourlyRate);
  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    "aria-label": t('salary_explained'),
    alignItems: "center",
    padding: 2
  }, other), (0, _core.jsx)(_Typography["default"], (0, _extends2["default"])({
    variant: "messageExtraSmall"
  }, TypographyProps, {
    css: _ref
  }), isLoading ? (0, _core.jsx)(_Skeleton["default"], {
    width: spacing(16)
  }) : t('{count}_euros_by_hour_with_CP', {
    count: roundedGrossHourlyRate
  })));
};

__signature__(Salary, "useTheme{{ spacing }}\nuseTranslation{t}\nuseIsLoading{isLoading}\nuseRoundNumber{roundedGrossHourlyRate}", function () {
  return [_useTheme2["default"], _useTranslation["default"], _useIsLoading["default"], _useRoundNumber["default"]];
});

var _default = Salary;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Salary, "Salary", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Header/Salary.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Header/Salary.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();